export default __webpack_public_path__ + "static/media/pendingSow1.c4d9b882.svg";